// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2lzwQ","info":"UpdateTermsInfo_info__2Uq1H"};